/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsWebPushOptions } from './FxIdDomainSettingsWebPushOptions';
import {
    instanceOfFxIdDomainSettingsWebPushOptions,
    FxIdDomainSettingsWebPushOptionsFromJSON,
    FxIdDomainSettingsWebPushOptionsFromJSONTyped,
    FxIdDomainSettingsWebPushOptionsToJSON,
} from './FxIdDomainSettingsWebPushOptions';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsWebPush
 * Настройки для веб пушей
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsWebPush = FxIdDomainSettingsWebPushOptions;

export function FxIdDomainSettingsPublicWebClientConfigOptionsWebPushFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsWebPush {
    return FxIdDomainSettingsPublicWebClientConfigOptionsWebPushFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsWebPushFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsWebPush {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsWebPushOptions(json)) {
        return FxIdDomainSettingsWebPushOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsWebPushToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsWebPushToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsWebPushToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsWebPush | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsWebPushOptions(value)) {
        return FxIdDomainSettingsWebPushOptionsToJSON(value as FxIdDomainSettingsWebPushOptions);
    }

    return {};
}

